import React, { Component } from "react";
import Responsive from "../../components/Responsive";
import { conditionalWidth, translate } from "../../utils/useful";
import ReactStars from "react-rating-stars-component";

class RoomReview extends Component {

    state = {
        cameras: [],
        positions: []
    }



    componentDidMount() {
        let path = window.location.pathname
        path = path.split('/')[path.split('/').length - 1]
        this.setState({ path })



    }






    render() {
        return (
            <div className={"room-lobby h-100 scroll-no-scrollbar "}>



                <Responsive height={'100%'} width={this.props.width} media={{ xs: "12", }}>

                    <div className="h-100  text-center flexcc flex-column px-4 py-4" style={{ backgroundColor: '#fff' }}>
                        <img className="mb-2" src="/assets/icons/portals/roomtest.svg" height={80} />
                        <p className="text-big text-bold">{this.state.path}</p>
                        <p className="text-normal mt-4">{translate("rooms.Feedback")}</p>
                        <p className="font-size-16 weight-300">{translate('rooms.Rate the quality')}</p>
                        <ReactStars count={5} size={30} edit={true} isHalf={true} color="#eee" activeColor="#ffcc00" />

                        <div className="w-100 flexcc">
                            <button onClick={() => this.props.goToRooms()} className='px-1 py-2 mrd-2 flexcc mt-3 room-btn' style={{ filter: !this.state.type == null ? 'saturate(20%) ' : '', borderRadius: 30, width: '150px' }}>
                                <p className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap' }}>{translate("rooms.Go To Home")}</p>
                            </button>
                            <button onClick={() => this.props.backToRoom()} className='px-1 py-2 mld-2 flexcc mt-3 room-btn2' style={{ filter: !this.state.type == null ? 'saturate(20%) ' : '', borderRadius: 30, width: '150px' }}>
                                <p className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap' }}>{translate("rooms.Back To Room")}</p>
                            </button>
                        </div>
                    </div>

                </Responsive>



            </div>
        )
    }



}


export default RoomReview;